import React, { useEffect, useState } from 'react';
import { estadoAvisos, activarAvisos, sincronizarAvisos } from '../lib/avisosWeb';

// Cartel para activar las notificaciones push de la web.
// tipo 'comercio': en los paneles de Cupido Delivery y Descuentos (queda hasta que se activan).
// tipo 'usuario': abajo de la pantalla en la app de usuarios (se puede cerrar por una semana).
const DIAS_CERRADO = 7;
const CLAVE_CERRADO = 'cupido_avisos_cerrado';

const TEXTOS = {
  comercio: {
    pendiente: 'Activá las notificaciones para enterarte al instante cuando te compran o te llega un pedido para enviar.',
    instalar: 'En iPhone las notificaciones llegan solo con la app instalada: tocá Compartir (el cuadrado con la flecha) › «Agregar a inicio» y abrila desde el ícono.',
  },
  usuario: {
    pendiente: 'Activá las notificaciones para enterarte cuando te escriben, tenés una conexión nueva o te mandan un regalo.',
    instalar: 'En iPhone las notificaciones llegan solo con la app instalada: tocá Compartir (el cuadrado con la flecha) › «Agregar a inicio» y abrila desde el ícono.',
  },
};
const DENEGADO = 'Las notificaciones están bloqueadas en este celular. Para activarlas, tocá el candado al lado de la dirección (o Ajustes › Notificaciones de la app) y permitilas.';

function cerradoHace() {
  try { return Date.now() - Number(localStorage.getItem(CLAVE_CERRADO) || 0) < DIAS_CERRADO * 864e5; } catch { return false; }
}

export default function ActivarAvisos({ tipo }) {
  const [estado, setEstado] = useState(estadoAvisos);
  const [cerrado, setCerrado] = useState(() => tipo === 'usuario' && cerradoHace());
  const [ocupado, setOcupado] = useState(false);

  // Con el permiso ya dado, registrar este celular para el comercio que entró
  // (los usuarios se registran al ingresar, en AuthContext)
  useEffect(() => { if (tipo === 'comercio') sincronizarAvisos(tipo); }, [tipo]);

  if (cerrado || estado === 'activo' || estado === 'no') return null;
  // A los usuarios no se les insiste si bloquearon o si están en el navegador del iPhone
  if (tipo === 'usuario' && estado !== 'pendiente') return null;

  const activar = async () => {
    setOcupado(true);
    try { setEstado(await activarAvisos(tipo)); }
    catch (e) { console.warn('[avisos]', e?.message); setEstado(estadoAvisos()); }
    finally { setOcupado(false); }
  };
  const cerrar = () => {
    try { localStorage.setItem(CLAVE_CERRADO, String(Date.now())); } catch { /* nada */ }
    setCerrado(true);
  };

  const texto = estado === 'denegado' ? DENEGADO : TEXTOS[tipo][estado];
  const contenido = (
    <>
      🔔 <strong>Notificaciones</strong> {texto}
      {estado === 'pendiente' && (
        <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn btn-primary btn-sm" onClick={activar} disabled={ocupado}>
            {ocupado ? 'Activando...' : 'Activar notificaciones'}
          </button>
          {tipo === 'usuario' && <button className="btn btn-ghost btn-sm" onClick={cerrar}>Ahora no</button>}
        </div>
      )}
    </>
  );

  if (tipo === 'comercio') return <div className="comercio-aviso">{contenido}</div>;
  return (
    <div style={{
      position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 900, maxWidth: 520, margin: '0 auto',
      background: 'var(--fondo-card)', border: '1px solid var(--borde-forte)', borderRadius: 'var(--radio-lg)',
      padding: '14px 18px', color: 'var(--texto-suave)', fontSize: 14, lineHeight: 1.6, boxShadow: '0 8px 24px var(--sombra)',
    }}>
      {contenido}
    </div>
  );
}
